var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderMedicinesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12970",
    d: "M36.375 5.625H3.708a2.333 2.333 0 0 0-2.333 2.333v56a2.333 2.333 0 0 0 2.333 2.333h32.667a2.333 2.333 0 0 0 2.333-2.333v-56a2.333 2.333 0 0 0-2.333-2.333z",
    transform: "translate(-.375 .042)",
    style: {
      strokeLinecap: "round",
      stroke: "#333",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12971",
    d: "M9.792 18.708a4.667 4.667 0 1 0-4.667-4.667 4.667 4.667 0 0 0 4.667 4.667z",
    transform: "translate(.542 .958)",
    style: {
      stroke: "#333",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12972",
    d: "M9.792 29.958a4.667 4.667 0 1 0-4.667-4.667 4.667 4.667 0 0 0 4.667 4.667z",
    transform: "translate(.542 3.708)",
    style: {
      stroke: "#333",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12973",
    d: "M9.792 41.208a4.667 4.667 0 1 0-4.667-4.667 4.667 4.667 0 0 0 4.667 4.667z",
    transform: "translate(.542 6.458)",
    style: {
      stroke: "#333",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12974",
    d: "M9.792 52.458a4.667 4.667 0 1 0-4.667-4.667 4.667 4.667 0 0 0 4.667 4.667z",
    transform: "translate(.542 9.208)",
    style: {
      stroke: "#333",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12975",
    d: "M24.792 18.708a4.667 4.667 0 1 0-4.667-4.667 4.667 4.667 0 0 0 4.667 4.667z",
    transform: "translate(4.208 .958)",
    style: {
      stroke: "#333",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12976",
    d: "M24.792 29.958a4.667 4.667 0 1 0-4.667-4.667 4.667 4.667 0 0 0 4.667 4.667z",
    transform: "translate(4.208 3.708)",
    style: {
      stroke: "#333",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12977",
    d: "M24.792 41.208a4.667 4.667 0 1 0-4.667-4.667 4.667 4.667 0 0 0 4.667 4.667z",
    transform: "translate(4.208 6.458)",
    style: {
      stroke: "#333",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12978",
    d: "M24.792 52.458a4.667 4.667 0 1 0-4.667-4.667 4.667 4.667 0 0 0 4.667 4.667z",
    transform: "translate(4.208 9.208)",
    style: {
      stroke: "#333",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12979",
    d: "M16.375 5.625v60.667",
    transform: "translate(3.292 .042)",
    style: {
      stroke: "#333",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12980",
    d: "M51.958 20.542a9.333 9.333 0 1 0-9.333-9.333 9.333 9.333 0 0 0 9.333 9.333z",
    transform: "translate(9.708 -.875)",
    style: {
      stroke: "#d24350",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12981",
    d: "m44.5 17.75 14-14",
    transform: "translate(10.167 -.417)",
    style: {
      stroke: "#d24350",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12982",
    d: "M46.333 41.167A9.333 9.333 0 1 0 37 31.833a9.333 9.333 0 0 0 9.333 9.334z",
    transform: "translate(8.333 4.167)",
    style: {
      stroke: "#d24350",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12983",
    d: "m38.875 38.375 14-14",
    transform: "translate(8.792 4.625)",
    style: {
      stroke: "#d24350",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12984",
    d: "M51.958 61.792a9.333 9.333 0 1 0-9.333-9.333 9.333 9.333 0 0 0 9.333 9.333z",
    transform: "translate(9.708 9.208)",
    style: {
      stroke: "#d24350",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12985",
    d: "m44.5 59 14-14",
    transform: "translate(10.167 9.667)",
    style: {
      stroke: "#d24350",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderMedicinesIcon);
export default __webpack_public_path__ + "static/media/order-medicines-icon.089ff554ca2789a1913fa5e4b0f82d95.svg";
export { ForwardRef as ReactComponent };